<script setup lang="ts">
import { Button } from "@/components/ui/button"
import axios from "axios"
import { useI18n } from 'vue-i18n';

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuGroup,
} from '@/components/ui/dropdown-menu'

import { Settings} from "lucide-vue-next";


const { t } = useI18n();

const props = withDefaults(defineProps<{
  columns: ColumnDef[]
  endpoint?: string
  enableAll?: boolean
}>(), {
  enableAll: false
})


const emit = defineEmits<{
  (e: 'toggleColumn', column: string): void;
}>();


async function toggleColumn(col, withEmit=true) {
  console.log("toggleColumn col=" + col.key)
  if (!props.endpoint) {
	return;
  }
  try {
    await axios.post(`/${props.endpoint}/togglecol`, {
      column: col.key,
      show: col.show
    });
    //toast({ title: "Saved", description: `${col.label} visibility updated.` });
  } catch (error: any) {
	const message =
		error.response?.data?.message ||
		error.response?.statusText ||
	    `Failed to update ${col.label}`
        toast({ title: "Error", description: message, variant: "destructive" });
  } finally {
	if (withEmit) {
		emit("toggleColumn")		
	}
  }
}

function selectAllColumns() {
  props.columns.forEach(c => {
    if (!c.show) {
		c.show = true;
		toggleColumn(c, true)	
	}
  })
  
  emit("toggleColumn")
}

function deselectAllColumns() {
  props.columns.forEach(c => {
    if (c.show) {
		c.show = false;
		toggleColumn(c, false)	
	}
  })
  
  emit("toggleColumn")
}
console.log("columns=" + JSON.stringify(props.columns))

</script>

<template>
<DropdownMenu>
  <DropdownMenuTrigger asChild>
    <Button variant="outline" size="sm" :title="t('view.columns_hs')">
      <Settings/> {{ t('view.columns') }}
    </Button>
  </DropdownMenuTrigger>

  <DropdownMenuContent class="w-60 max-h-64 overflow-y-auto z-[10001]">
    <DropdownMenuLabel>{{ t('view.columns_hs') }}</DropdownMenuLabel>

    <DropdownMenuSeparator />

    <DropdownMenuItem v-if="props.enableAll"
      class="flex items-center gap-2 px-2 py-1 font-semibold text-red-600 cursor-pointer"
      @click="selectAllColumns"
    >
      {{ t('view.all') }}
    </DropdownMenuItem>

    <DropdownMenuItem v-if="props.enableAll"
      class="flex items-center gap-2 px-2 py-1 font-semibold text-red-600 cursor-pointer"
      @click="deselectAllColumns"
    >
      {{ t('view.none') }}
    </DropdownMenuItem>

    <DropdownMenuSeparator />

    <DropdownMenuGroup>
      <DropdownMenuItem
        v-for="c in columns.filter(c => c.key !== 'actions' && c.key !== 'buffer')"
        :key="c.key"
        class="flex items-center justify-between"
      >
        <label class="flex items-center gap-2 cursor-pointer w-full">
          <input 
            :disabled="!c.togglefilter"
            type="checkbox" 
            v-model="c.show" 
            class="accent-blue-500"
            @change="toggleColumn(c)"
          />
          <span> {{ c.label }} </span>
        </label>
      </DropdownMenuItem>
    </DropdownMenuGroup>
  </DropdownMenuContent>
</DropdownMenu>
</template>
